import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const STEPS = [
  {
    get title() { return translateInterfaceText("1. Crie o fluxo"); },
    get text() { return translateInterfaceText("Dê um nome ao fluxo. Cada fluxo é um funil de vídeos curtos em que o visitante escolhe o próprio caminho."); },
  },
  {
    get title() { return translateInterfaceText("2. Envie os vídeos"); },
    get text() { return translateInterfaceText("Os vídeos são enviados dentro do fluxo e ficam só nele: não aparecem em \"Meus vídeos\". Assim que terminam de processar, já podem ser usados nas etapas."); },
  },
  {
    get title() { return translateInterfaceText("3. Monte as etapas"); },
    get text() { return translateInterfaceText("Cada etapa é um vídeo com uma pergunta e até 4 opções. Cada opção leva a outra etapa ou a uma saída, como o checkout ou o WhatsApp. Você escolhe quando as opções aparecem e se o vídeo pausa até o visitante responder."); },
  },
  {
    get title() { return translateInterfaceText("4. Personalize o player"); },
    get text() { return translateInterfaceText("No tema, defina o formato do vídeo, as cores, o estilo das opções, a barra de progresso e como o vídeo começa (prévia sem som ou clicar para iniciar)."); },
  },
  {
    get title() { return translateInterfaceText("5. Publique e cole o código"); },
    get text() { return translateInterfaceText("O rascunho é salvo sozinho e não muda o que está no ar. Pré-visualize, publique e cole o código na sua página. O código é sempre o mesmo: publicar de novo atualiza o vídeo no site."); },
  },
  {
    get title() { return translateInterfaceText("6. Acompanhe as métricas"); },
    get text() { return translateInterfaceText("Veja quantos visitantes passam por cada etapa, qual opção escolhem, quantos chegam ao checkout e a retenção de cada vídeo. Só o primeiro clique de cada visitante conta como play no seu plano."); },
  },
];

interface HowItWorksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

// Explicação do recurso, no mesmo formato do "Como funciona?" do Teste A/B e do Hook Track.
export function HowItWorksDialog({ open, onOpenChange }: HowItWorksDialogProps) {
  useLanguage();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{translateInterfaceText("Como funciona a VSL Dinâmica")}</DialogTitle>
          <DialogDescription>
            {translateInterfaceText("Um funil de vídeos em que cada resposta do visitante leva ao próximo vídeo, até o checkout.")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          {STEPS.map((step) => (
            <div key={step.title} className="border-l-4 border-blue-500 py-2 pl-4">
              <h3 className="mb-1 font-medium text-foreground">{step.title}</h3>
              <p className="text-sm text-gray-600">{step.text}</p>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
